<template>
  <v-dialog
    v-model="localDialog"
    width="35%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
  >
    <v-card>
      <v-card-title class="text-h6">
        <span>{{ isEntryMode ? "Add Weekend" : "Update Weekend" }}</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form @submit.prevent="submit" ref="WeekendSetup">
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Name"
                type="text"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="name.value.value"
                :error-messages="name.errorMessage.value"
                clearable
              ></v-text-field>

              <v-select
                clearable
                density="compact"
                chips
                label="Weekend Days"
                :items="getDaysList"
                item-title="days"
                item-value="id"
                v-model="day_ids.value.value"
                multiple
                variant="outlined"
                bg-color="grey-lighten-4"
              />

              <v-select
                v-model="department_ids.value.value"
                :items="getHrmDepartmentList"
                item-title="name"
                item-value="id"
                label="Department"
                multiple
                chips
                clearable
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
              />

              <v-select
                clearable
                density="compact"
                chips
                label="Shift"
                :items="getShiftList"
                item-title="shift_name"
                item-value="id"
                v-model="shift_ids.value.value"
                :error-messages="shift_ids.errorMessage.value"
                multiple
                variant="outlined"
                bg-color="grey-lighten-4"
              />
              <v-date-input
                label="Start Date"
                density="compact"
                prepend-icon=""
                prepend-inner-icon="mdi-calendar"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="start_date.value.value"
                :error-messages="start_date.errorMessage.value"
                autocomplete="off"
                clearable
              ></v-date-input>

              <v-date-input
                label="End Date"
                density="compact"
                prepend-icon=""
                prepend-inner-icon="mdi-calendar"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="end_date.value.value"
                :error-messages="end_date.errorMessage.value"
                autocomplete="off"
                clearable
              ></v-date-input>

              <v-text-field
                label="Remarks (Optional)"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="remarks.value.value"
                :error-messages="remarks.errorMessage.value"
                clearable
              ></v-text-field>

              <v-checkbox
                label="Active"
                v-model="status.value.value"
                :error-messages="status.errorMessage.value"
                density="compact"
                variant="outlined"
                hide-details
                single-line
                color="primary"
                value="1"
              ></v-checkbox>
              <input v-model="weekend_id.value.value" type="hidden" />
            </v-col>
          </v-row>

          <v-divider></v-divider>
          <v-card-actions>
            <v-layout class="justify-end">
              <v-btn class="bg-red" variant="flat" @click="closeDialog"
                >Close</v-btn
              >
              <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                {{ isEntryMode ? "Save" : "Update" }}
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
  name: "WeekendSetup",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({
        weekend_id: null,
        name: "",
        department_ids: [],
        shift_ids: [],
        day_ids: [],
        start_date: "",
        end_date: "",
        remarks: "",
        status: "1",
      }),
    },
  },
  data() {
    return {
      localDialog: this.dialog,
      errorMessages: "",
      loading: false,
      isEntryMode: true,
    };
  },
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.weekend_id;
        const departments = Array.isArray(newData.department_ids)
          ? newData.department_ids
          : (newData.departments || []).map((dep) => dep.department_id);
        const shifts = Array.isArray(newData.shift_ids)
          ? newData.shift_ids
          : (newData.shifts || []).map((shift) => shift.shift_id);
        const days = Array.isArray(newData.day_ids)
          ? newData.day_ids
          : (newData.days || []).map((day) => day.day_id);

        this.weekend_id.setValue(newData.weekend_id || newData.id || "", false);
        this.name.setValue(newData.name || "", false);
        this.department_ids.setValue(departments, false);
        this.shift_ids.setValue(shifts, false);
        this.day_ids.setValue(days, false);
        this.start_date.setValue(newData.start_date || "", false);
        this.end_date.setValue(newData.end_date || "", false);
        this.remarks.setValue(newData.remarks || "", false);
        this.status.setValue(String(newData.status ?? "1"), false);
      },
      immediate: true,
    },
  },
  created() {
    if (this.$store.getters.getHrmDepartmentList.length === 0) {
      this.$store.dispatch("getHrmDepartmentList");
    }
    if (this.$store.getters.getShiftList.length === 0) {
      this.$store.dispatch("getShiftList");
    }
    // console.log(this.$store.getters.getDaysListrst)
    if (this.$store.getters.getDaysList.length === 0) {
      this.$store.dispatch("getDaysList");
    }
  },
  computed: {
    getHrmDepartmentList() {
      return this.$store.getters.getHrmDepartmentList;
    },
    getShiftList() {
      return this.$store.getters.getShiftList;
    },
    getDaysList() {
      return this.$store.getters.getDaysList;
    },
  },
  methods: {
    updateDialog(val) {
      this.$emit("update:dialog", val);
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
  setup(props, { emit }) {  
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        name: yup.string().required().trim().label("Name"),
        department_ids: yup.array().min(1).label("Department"),
        shift_ids: yup.array().min(1).label("Shift"),
        start_date: yup.date().required().label("Start Date"),
        end_date: yup
          .date()
          .nullable()
          .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? null : value
          )
          .min(yup.ref("start_date"), "End Date cannot be before Start Date")
          .label("End Date"),
        remarks: yup.string().max(250).nullable().trim().label("Remarks"),
        status: yup.string().label("Status"),
        day_ids: yup.array().min(1).label("Days"), // only if you're still using `days` separately
      }),
    });

    const weekend_id = useField("weekend_id");
    const name = useField("name");
    const day_ids = useField("day_ids");
    const department_ids = useField("department_ids");
    const shift_ids = useField("shift_ids");
    const remarks = useField("remarks");
    const start_date = useField("start_date");
    const end_date = useField("end_date");
    const status = useField("status");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();

    const submit = handleSubmit((values) => {
      values.start_date = formattedDate(start_date.value.value);
      values.end_date = formattedDate(end_date.value.value);
      store
        .dispatch("saveUpdateWeekend", values)
        .then((response) => {
          resetForm();
          emit("update:dialog", false);
          toast.success(response.data.message);
          loading.value = true;
          store
            .dispatch("getWeekendList")
            .then((data) => {
              loading.value = false;
            })
            .catch((error) => {
              loading.value = false;
              toast.error(error.response.data.message);
            });
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      submit,
      weekend_id,
      name,
      department_ids,
      shift_ids,
      day_ids,
      start_date,
      end_date,
      remarks,
      status,
      errorMessages,
      resetForm,
      loading,
    };
  },
  mounted() {},
};
</script>